/* Dead Romance v2 — DOM behaviour. Ports unchanged to assets/dr-v2.js.
   Reads everything from the DOM (data-* / JSON blobs); no store data in here. */
(function () {
  "use strict";
  document.documentElement.classList.add("dr-js");   /* enables JS-only motion states in CSS */
  var body = document.body;

  var header = document.querySelector("[data-dr-header]");

  /* --- mobile menu --- */
  var menuBtn = document.querySelector("[data-dr-menu-toggle]");
  var menu = document.querySelector("[data-dr-menu]");
  function setMenu(open) {
    if (!menuBtn || !menu) return;
    menuBtn.setAttribute("aria-expanded", open ? "true" : "false");
    menu.hidden = !open;
    if (open) header.setAttribute("data-menu-open", ""); else header.removeAttribute("data-menu-open");
    if (open) { var first = menu.querySelector("a"); if (first) first.focus(); }
    else menuBtn.focus();
  }
  if (menuBtn) menuBtn.addEventListener("click", function () {
    setMenu(menuBtn.getAttribute("aria-expanded") !== "true");
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && menuBtn && menuBtn.getAttribute("aria-expanded") === "true") setMenu(false);
  });

  /* --- header search (inline form inside the capsule) --- */
  var searchBtn = document.querySelector("[data-dr-search-open]");
  var searchForm = document.querySelector("[data-dr-search]");
  function setSearch(open) {
    if (!searchBtn || !searchForm) return;
    searchBtn.setAttribute("aria-expanded", open ? "true" : "false");
    if (open) header.setAttribute("data-search-open", ""); else header.removeAttribute("data-search-open");
    if (open) searchForm.querySelector('input[type="search"]').focus(); else searchBtn.focus();
  }
  if (searchBtn) searchBtn.addEventListener("click", function () { setSearch(true); });
  document.addEventListener("click", function (e) { if (e.target.closest("[data-dr-search-close]")) setSearch(false); });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && header && header.hasAttribute("data-search-open")) setSearch(false);
  });

  /* --- cart --- */
  var C = window.DRCore;
  var drawer = document.querySelector("[data-dr-drawer]");
  var scrim = document.querySelector("[data-dr-scrim]");
  var linesEl = document.querySelector("[data-dr-lines]");
  var emptyEl = document.querySelector("[data-dr-cart-empty]");
  var footEl = document.querySelector("[data-dr-cart-foot]");
  var totalEl = document.querySelector("[data-dr-total]");
  var bogoEl = document.querySelector("div[data-dr-bogo]");
  var toastEl = document.querySelector("[data-dr-toast]");
  var bogoCfg = { handles: [] };
  var cfgEl = document.querySelector("script[data-dr-bogo]");
  if (cfgEl) { try { bogoCfg = JSON.parse(cfgEl.textContent); } catch (e) {} }
  /* Spend-threshold free tee. When it's on it owns the cart's offer slot and the BOGO prompts stay quiet. */
  var giftEl = document.querySelector("div[data-dr-gift]");
  var giftCfg = { handles: [] };
  var giftCfgEl = document.querySelector("script[data-dr-gift]");
  if (giftCfgEl) { try { giftCfg = JSON.parse(giftCfgEl.textContent); } catch (e) {} }
  var giftOn = !!(giftEl && giftCfg.handles && giftCfg.handles.length);
  var upsellEl = document.querySelector("[data-dr-upsell]");
  var giftPanel = document.querySelector("[data-dr-giftpanel]");
  var pendingKeys = {};
  var lastState = null;
  var opener = null;
  /* Cart mutations run one at a time: parallel responses can land out of order and
     an older snapshot would be painted over a newer one. */
  var queue = Promise.resolve();
  function enqueue(fn) {
    var p = queue.then(fn);
    queue = p["catch"](function () {});
    return p;
  }

  function say(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.setAttribute("data-open", "true");
    clearTimeout(say.t);
    say.t = setTimeout(function () { toastEl.setAttribute("data-open", "false"); }, 2600);
  }
  function asJson(r) {
    return r.json().then(function (j) {
      if (!r.ok) throw new Error(j.description || j.message || "Cart error");
      return j;
    });
  }
  function readCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(asJson).then(C.mapCart);
  }

  /* Re-rendering lines via innerHTML destroys the focused control; remember which
     line + control had focus and put it back afterwards (keyboard users keep their place). */
  function focusedLineControl() {
    var a = document.activeElement;
    if (!a || !linesEl.contains(a)) return null;
    var li = a.closest("[data-dr-line]");
    return li && { key: li.getAttribute("data-dr-line"),
                   sel: a.hasAttribute("data-dr-qty") ? '[data-dr-qty="' + a.getAttribute("data-dr-qty") + '"]'
                      : a.hasAttribute("data-dr-remove") ? "[data-dr-remove]" : null };
  }
  function restoreFocus(f) {
    if (!f) return;
    var target = null;
    Array.prototype.forEach.call(linesEl.querySelectorAll("[data-dr-line]"), function (li) {
      if (li.getAttribute("data-dr-line") === f.key && f.sel) target = li.querySelector(f.sel);
    });
    (target || drawer.querySelector("[data-dr-drawer-close]")).focus();
  }

  function renderCart(state) {
    var hadFocus = focusedLineControl();
    lastState = state;
    document.querySelectorAll("[data-dr-cart-count]").forEach(function (el) { el.textContent = state.count; });
    document.querySelectorAll("[data-dr-count-badge]").forEach(function (el) { el.setAttribute("data-count", state.count); });
    var has = state.items.length > 0;
    emptyEl.hidden = has;
    footEl.hidden = !has;
    linesEl.innerHTML = giftSlot(state) + state.items.map(function (l) {
      var busy = pendingKeys[l.key] ? " is-loading" : "";
      var price = l.linePrice === 0 ? "Free" : C.money(l.linePrice);
      return '<li class="dr-line' + busy + '" id="' + C.esc(l.id) + '" data-dr-line="' + C.esc(l.key) + '">' +
        '<a class="dr-line__img" href="' + C.esc(l.url) + '"><img src="' + C.esc(C.imgAt(l.image, 160)) +
        '" width="80" height="100" alt="" loading="lazy"></a>' +
        '<div class="dr-line__info"><a class="dr-line__name" href="' + C.esc(l.url) + '">' + C.esc(l.name) + '</a>' +
        (l.size ? '<span class="dr-xs dr-mute">' + C.esc(l.size) + '</span>' : '') +
        '<div class="dr-line__ctl">' + (l.gift && l.qty === 1 ? "" : '<div class="dr-qty">' +   /* the picked free tee is one unit: no stepper */
        '<button type="button" data-dr-qty="-1" aria-label="Reduce quantity of ' + C.esc(l.name) + '">&minus;</button>' +
        '<span aria-live="polite">' + l.qty + '</span>' +
        '<button type="button" data-dr-qty="1" aria-label="Increase quantity of ' + C.esc(l.name) + '">+</button>' +
        '</div>') + '<button type="button" class="dr-line__remove dr-xs" data-dr-remove>Remove</button></div></div>' +
        '<span class="dr-line__price">' + C.esc(price) + '</span></li>';
    }).join("");
    /* Discount applied (the free tee): show the full price struck through beside what they pay. */
    totalEl.innerHTML = (state.gross > state.total
      ? '<s class="dr-was"><span class="dr-visually-hidden">Was </span>' + C.esc(C.money(state.gross)) + '</s> ' : "") +
      C.esc(C.money(state.total));
    var b = giftOn ? { mode: "none" } : C.bogoState(state, bogoCfg.handles);
    bogoEl.setAttribute("data-mode", b.mode);
    bogoEl.hidden = b.mode === "none";
    bogoEl.innerHTML = b.mode === "odd"
      ? C.esc(bogoCfg.odd) + ' <a class="dr-link" href="' + C.esc(bogoCfg.shopUrl) + '">Shop</a>'
      : b.mode === "even" ? C.esc(bogoCfg.even) : "";
    if (giftOn) renderGift(state);
    restoreFocus(hadFocus);
  }

  /* the rail's arrows measure the track, which is 0 wide while the drawer or carousel is hidden */
  function syncUpsellRail() {
    var r = upsellEl && upsellEl.querySelector("[data-dr-rail]");
    if (r) r.dispatchEvent(new Event("scroll"));
  }
  /* Free tee earned but not picked: an empty $0 line at the top of the list, its Choose button opens the panel. */
  function giftSlot(state) {
    if (!giftOn || C.giftState(state, giftCfg.handles, giftCfg.threshold).mode !== "pick") return "";
    return '<li class="dr-line dr-line--slot" data-dr-gift-slot><span class="dr-line__img dr-slot__img" aria-hidden="true">+</span>' +
      '<div class="dr-line__info"><span class="dr-line__name">' + C.esc(giftCfg.slotTitle) + '</span>' +
      '<span class="dr-xs dr-mute">' + C.esc(giftCfg.slotSub) + '</span>' +
      '<div class="dr-line__ctl"><button type="button" class="dr-slot__btn" data-dr-gift-open aria-haspopup="dialog">' +
      C.esc(giftCfg.slotButton) + '</button></div></div><span class="dr-line__price">' + C.esc(giftCfg.free || "Free") + '</span></li>';
  }
  /* The picker is a panel that slides over the cart inside the drawer: the rest of the drawer goes inert while it's
     open, Back / Esc / a pick slide it away again. */
  function setPanel(open, instant) {
    if (!giftPanel || open === !giftPanel.hidden) return;
    Array.prototype.forEach.call(drawer.children, function (el) { if (el !== giftPanel) el.inert = open; });
    if (open) {
      giftPanel.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { giftPanel.setAttribute("data-open", "true"); }); });
      giftPanel.querySelector("[data-dr-giftpanel-close]").focus();
      return;
    }
    giftPanel.removeAttribute("data-open");
    var ms = instant ? 0 : parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--dr-t-drawer")) || 0;
    setTimeout(function () { if (!giftPanel.hasAttribute("data-open")) giftPanel.hidden = true; }, ms);
    var back = linesEl.querySelector("[data-dr-gift-open]") || giftEl.querySelector("[data-dr-gift-msg]");
    if (!instant && back) back.focus();
  }

  function renderGift(state) {
    var g = C.giftState(state, giftCfg.handles, giftCfg.threshold);
    var ship = giftCfg.ship || 0;
    var left = function (t, cents) { return (t || "").replace("{remaining}", C.money(cents)); };
    var text = g.mode === "progress"
      ? (ship && g.spend < ship ? left(giftCfg.shipProgress, ship - g.spend)
         : left(ship ? giftCfg.progressShipped : giftCfg.progress, g.remaining))
      : left({ pick: giftCfg.unlocked, applied: giftCfg.applied, keep: giftCfg.keep }[g.mode], g.remaining);
    giftEl.setAttribute("data-mode", g.mode);
    giftEl.hidden = g.mode === "none";
    giftEl.querySelector("[data-dr-gift-msg]").textContent = text;
    /* tier bar: one track, a stop per reward */
    var stops = Array.prototype.slice.call(giftEl.querySelectorAll("[data-dr-tier]"));
    var t = C.tierState(g, giftCfg.threshold, stops.map(function (el) { return Number(el.getAttribute("data-dr-tier")); }));
    giftEl.querySelector("[data-dr-gift-fill]").style.width = Math.round(t.fill * 100) + "%";
    stops.forEach(function (el, i) { el.toggleAttribute("data-reached", t.reached[i]); });
    if (g.mode !== "pick") setPanel(false);
    /* upsell carousel under the lines until the tee is earned: everything not already in the cart */
    if (upsellEl) {
      var inCart = {};
      state.items.forEach(function (l) { inCart[l.handle] = true; });
      var shown = 0;
      Array.prototype.forEach.call(upsellEl.querySelectorAll("[data-dr-upsell-item]"), function (li) {
        li.hidden = !!inCart[li.getAttribute("data-dr-upsell-item")];
        if (!li.hidden) shown++;
      });
      upsellEl.hidden = !(g.mode === "progress" || g.mode === "keep") || !shown;
      syncUpsellRail();
    }
    /* product page offer box: live distance to the tee */
    document.querySelectorAll("[data-dr-pdp-gift-status]").forEach(function (el) {
      var empty = !state.items.length;
      /* framed by items (any two items qualify): empty cart / one more item / earned */
      el.textContent = g.mode === "pick" || g.mode === "applied" ? el.getAttribute("data-earned")
        : empty && el.hasAttribute("data-empty") ? el.getAttribute("data-empty")
        : left(el.getAttribute("data-away"), empty ? giftCfg.threshold : g.remaining);
    });
  }

  function focusables() {
    return Array.prototype.filter.call(
      drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null && !el.closest("[inert]"); });
  }
  function openDrawer(returnTo) {
    if (!drawer) return;
    if (!drawer.hidden) return;
    opener = returnTo || document.activeElement;
    drawer.hidden = false; scrim.hidden = false;
    requestAnimationFrame(function () { drawer.setAttribute("data-open", "true"); scrim.setAttribute("data-open", "true"); syncUpsellRail(); });
    document.documentElement.setAttribute("data-dr-locked", "");
    var f = focusables(); if (f.length) f[0].focus();
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    if (giftPanel) setPanel(false, true);
    drawer.setAttribute("data-open", "false"); scrim.setAttribute("data-open", "false");
    document.documentElement.removeAttribute("data-dr-locked");
    var ms = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--dr-t-drawer")) || 0;
    setTimeout(function () { drawer.hidden = true; scrim.hidden = true; }, ms);
    if (opener && opener.focus) opener.focus();
  }

  function add(formData, returnTo) {
    return enqueue(function () {
      return fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: formData })
        .then(asJson).then(readCart);
    }).then(function (s) { renderCart(s); openDrawer(returnTo); return s; })
      ["catch"](function (e) { say(e.message); throw e; });
  }

  function changeLine(key, qty) {
    pendingKeys[key] = true;
    if (lastState) renderCart(lastState);
    return enqueue(function () {
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(asJson);
    }).then(C.mapCart)
      .then(function (s) { delete pendingKeys[key]; renderCart(s); return s; })
      ["catch"](function (e) {
        delete pendingKeys[key];
        say(e.message);
        return readCart().then(renderCart);
      });
  }

  if (drawer) {
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-dr-cart-open]")) { e.preventDefault(); openDrawer(); }
      if (e.target.closest("[data-dr-drawer-close]") || e.target.closest("[data-dr-scrim]")) closeDrawer();
      if (e.target.closest("[data-dr-gift-open]")) setPanel(true);
      if (e.target.closest("[data-dr-giftpanel-close]")) setPanel(false);
    });
    document.addEventListener("keydown", function (e) {
      if (drawer.hidden) return;
      if (e.key === "Escape") { if (giftPanel && !giftPanel.hidden) setPanel(false); else closeDrawer(); return; }
      if (e.key !== "Tab") return;
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    linesEl.addEventListener("click", function (e) {
      var li = e.target.closest("[data-dr-line]"); if (!li) return;
      var key = li.getAttribute("data-dr-line");
      if (pendingKeys[key]) return;
      var line = lastState && lastState.items.filter(function (l) { return l.key === key; })[0];
      if (!line) return;
      var q = e.target.closest("[data-dr-qty]");
      if (q) changeLine(key, Math.max(0, line.qty + Number(q.getAttribute("data-dr-qty"))));
      else if (e.target.closest("[data-dr-remove]")) changeLine(key, 0);
    });
    /* a size tap in the panel adds that tee free (hidden _free_tee) and slides back to the cart */
    if (giftPanel) giftPanel.addEventListener("submit", function (e) {
      var b = e.submitter;
      if (!b || !b.value) return;                     /* no submitter support -> native POST */
      e.preventDefault();
      var fd = new FormData(e.target); fd.append("id", b.value);
      b.disabled = true;
      add(fd).then(function () { setPanel(false); })["catch"](function () {})
        .then(function () { b.disabled = false; });
    });
    if (upsellEl) upsellEl.addEventListener("submit", function (e) {
      var f = e.target;
      e.preventDefault();
      var sel = f.querySelector("select[name=id]");
      if (!sel.value) { say(upsellEl.getAttribute("data-dr-hint-text") || "Pick a size"); sel.focus(); return; }
      var b = f.querySelector("button");
      b.disabled = true;
      add(new FormData(f))["catch"](function () {}).then(function () { b.disabled = false; });
    });
    window.addEventListener("pageshow", function (e) { if (e.persisted) { pendingKeys = {}; readCart().then(renderCart); } });
    readCart().then(renderCart)["catch"](function () {});
  }

  window.DRCart = { open: openDrawer, close: closeDrawer, refresh: function () { return readCart().then(renderCart); }, add: add };
  /* --- card photo swipe: keep the dots in step with the track (touch screens only show them) --- */
  document.addEventListener("scroll", function (e) {
    var t = e.target;
    if (!t.matches || !t.matches("[data-dr-card-track]")) return;
    var dots = t.parentNode.querySelector(".dr-card__dots");
    if (!dots) return;
    var i = Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
    Array.prototype.forEach.call(dots.children, function (d, n) { d.toggleAttribute("data-on", n === i); });
  }, true);

  /* --- pdp --- (a function: a colorway swap replaces the section and runs it again) */
  var pdpSticky = null, stickyTick = false, stickyBound = false;
  function initPdp() {
    var form = document.querySelector("[data-dr-atc-form]");
    if (!form) return;
    var prodEl = document.querySelector("script[data-dr-product]");
    var prod = prodEl ? JSON.parse(prodEl.textContent) : { variants: [] };
    var variants = prod.variants;
    var stockEl = document.querySelector("[data-dr-stock]");
    var stockText = stockEl && stockEl.querySelector("[data-dr-stock-text]");
    var sizeHint = form.querySelector("[data-dr-size-hint]");
    var sizesBox = form.querySelector(".dr-sizes");
    var idInput = form.querySelector("[data-dr-variant-id]");
    var atcBtns = [form.querySelector("[data-dr-atc]")].concat(
      Array.prototype.slice.call(document.querySelectorAll("[data-dr-atc-mirror]")));
    var mainAtc = atcBtns[0];
    var syncAtc = function () {
      var picked = form.querySelector('input[name="options[Size]"]:checked');
      var v = picked && variants.filter(function (x) { return x.title === picked.value && x.available; })[0];
      idInput.value = v ? v.id : "";
      var anyAvailable = form.querySelector('input[name="options[Size]"]:not(:disabled)');
      var label = v ? mainAtc.getAttribute("data-label-add")
        : anyAvailable ? mainAtc.getAttribute("data-label-select")
        : (mainAtc.getAttribute("data-label-soldout") || "Sold out");
      /* Black and live until a size is picked; truly disabled only when nothing is available. */
      atcBtns.forEach(function (b) {
        b.disabled = !anyAvailable;
        b.setAttribute("aria-disabled", v ? "false" : "true");
        b.textContent = label;
      });
      if (v && sizeHint) sizeHint.hidden = true;
      var expressBtn = form.querySelector("[data-dr-express-btn]");
      if (expressBtn) expressBtn.setAttribute("aria-disabled", v ? "false" : "true");
      if (stockEl) {
        /* Inventory comes from Shopify (only when tracked); a low-stock line is never invented. */
        var L = prod.labels || {}, level = "in", text = L.inStock || "In stock";
        if (!anyAvailable) { level = "out"; text = L.soldOut || "Sold out"; }
        else if (v && typeof v.inventory === "number" && v.inventory > 0 && v.inventory <= (prod.lowStock || 0)) {
          level = "low"; text = (L.low || "Only {n} left").replace("{n}", v.inventory);
        }
        stockEl.setAttribute("data-level", level);
        stockText.textContent = text;
      }
    };
    function guideToSize() {
      if (sizeHint) sizeHint.hidden = false;
      sizesBox.setAttribute("data-attention", "");
      setTimeout(function () { sizesBox.removeAttribute("data-attention"); }, 320);
      var firstSize = form.querySelector('input[name="options[Size]"]:not(:disabled)');
      if (firstSize) firstSize.focus();
    }
    /* Quick buy (Shopify's payment button) needs a variant: hold it until a size is picked. Capture phase so
       this runs before Shopify's own handler. */
    var express = form.querySelector("[data-dr-express]");
    if (express) express.addEventListener("click", function (e) {
      if (idInput.value || e.target.closest("[data-dr-more-payments]")) return;
      e.preventDefault(); e.stopPropagation(); guideToSize();
    }, true);
    form.addEventListener("change", syncAtc);
    syncAtc();
    form.addEventListener("submit", function (e) {
      if (!idInput.value) { e.preventDefault(); guideToSize(); return; }   /* no size yet: guide, don't post */
      if (!window.DRCart) return;                             /* no JS cart -> native POST to /cart/add */
      e.preventDefault();
      var returnTo = e.submitter || mainAtc;   /* captured before disabling drops focus to <body> */
      atcBtns.forEach(function (b) { b.disabled = true; });
      window.DRCart.add(new FormData(form), returnTo)["catch"](function () {})
        .then(syncAtc);
    });
    /* size guide: pop-up dialog; the link's real href (/pages/size-guide) is the no-JS fallback */
    var sgLink = document.querySelector("[data-dr-size-guide]");
    var sgDlg = document.querySelector("[data-dr-size-guide-dialog]");
    if (sgLink && sgDlg && typeof sgDlg.showModal === "function") {
      sgLink.addEventListener("click", function (e) { e.preventDefault(); sgDlg.showModal(); });
      sgDlg.querySelector("[data-dr-size-guide-close]").addEventListener("click", function () { sgDlg.close(); });
      sgDlg.addEventListener("click", function (e) { if (e.target === sgDlg) sgDlg.close(); });   /* backdrop */
    }

    /* sticky ATC: shown once the main ATC has scrolled above the viewport. Position is read on every
       scroll frame: an IntersectionObserver misses a fast fling that carries the button from below the
       fold straight to above it without ever intersecting (no state change -> no callback). */
    var sticky = document.querySelector("[data-dr-sticky]");
    pdpSticky = null;
    if (sticky) {
      pdpSticky = function () {
        stickyTick = false;
        var show = mainAtc.getBoundingClientRect().bottom < 0;
        if (sticky.hidden === show) { sticky.hidden = !show; sticky.inert = !show; }
      };
      sticky.inert = true;
      if (!stickyBound) {   /* window listeners once; they call whichever page is current */
        stickyBound = true;
        window.addEventListener("scroll", function () {
          if (!stickyTick && pdpSticky) { stickyTick = true; requestAnimationFrame(function () { if (pdpSticky) pdpSticky(); }); }
        }, { passive: true });
        window.addEventListener("resize", function () { if (pdpSticky) pdpSticky(); });
      }
      pdpSticky();
    }
  }
  initPdp();

  /* --- rails (Worn): prev/next buttons, disabled at the ends --- */
  Array.prototype.forEach.call(document.querySelectorAll("[data-dr-rail]"), function (railEl) {
    var sec = railEl.closest("section");
    var prevBtn = sec && sec.querySelector("[data-dr-rail-prev]");
    var nextBtn = sec && sec.querySelector("[data-dr-rail-next]");
    var syncRail = function () {
      if (!prevBtn || !nextBtn) return;
      prevBtn.disabled = railEl.scrollLeft <= 2;
      nextBtn.disabled = railEl.scrollLeft + railEl.clientWidth >= railEl.scrollWidth - 2;
    };
    var step = function (dir) {
      var still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      railEl.scrollBy({ left: dir * railEl.clientWidth * 0.8, behavior: still ? "auto" : "smooth" });
    };
    if (prevBtn) prevBtn.addEventListener("click", function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { step(1); });
    railEl.addEventListener("scroll", syncRail, { passive: true });
    window.addEventListener("resize", syncRail);
    syncRail();
  });

  /* --- card quick add: <details> + a real form of submit buttons (name=id) underneath ---
     data-state="open" drives a CSS slide; <details> stays open until the slide-up finishes. */
  var qaStill = function () { return window.matchMedia("(prefers-reduced-motion: reduce)").matches; };
  function qaOpen(d) {
    d.open = true;
    requestAnimationFrame(function () { requestAnimationFrame(function () { d.setAttribute("data-state", "open"); }); });
  }
  function qaClose(d, focus) {
    if (!d.open) return;
    if (focus) d.querySelector("summary").focus();
    d.removeAttribute("data-state");
    var sizes = d.querySelector(".dr-qa__sizes");
    var done = function () { if (d.getAttribute("data-state") !== "open") d.open = false; };
    if (qaStill()) { done(); return; }
    var t = setTimeout(done, 360);
    sizes.addEventListener("transitionend", function onEnd(ev) {
      if (ev.propertyName !== "transform") return;
      sizes.removeEventListener("transitionend", onEnd); clearTimeout(t); done();
    });
  }
  document.addEventListener("click", function (e) {
    var s = e.target.closest && e.target.closest(".dr-qa > summary");
    Array.prototype.forEach.call(document.querySelectorAll("details.dr-qa[open]"), function (o) {
      if (!s || o !== s.parentNode) qaClose(o);
    });
    if (!s) return;
    e.preventDefault();                                   /* we drive open/close so both can animate */
    var d = s.parentNode;
    if (d.open && d.getAttribute("data-state") === "open") qaClose(d);
    else if (d.open) d.setAttribute("data-state", "open"); /* re-tap mid-close: glide back down */
    else qaOpen(d);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var o = document.querySelector('details.dr-qa[data-state="open"]');
    if (o) qaClose(o, true);
  });
  document.addEventListener("submit", function (e) {
    var f = e.target.closest && e.target.closest("[data-dr-qa-form]");
    if (!f || !window.DRCart) return;            /* no JS cart -> native POST id=<variant> to /cart/add */
    var btn = e.submitter || document.activeElement;
    if (!btn || btn.name !== "id") return;
    e.preventDefault();
    var d = f.closest("details"), summary = d.querySelector("summary");
    var fd = new FormData();
    fd.append("id", btn.value); fd.append("quantity", "1");
    d.setAttribute("data-busy", "");
    window.DRCart.add(fd, summary)
      .then(function () { qaClose(d); })["catch"](function () {})
      .then(function () { d.removeAttribute("data-busy"); });
  });

  /* --- pdp gallery: snap track + progress bar; desktop arrows + thumbnails (Pythia slider) --- */
  function initGallery() {
    var track = document.querySelector("[data-dr-gallery-track]");
    if (!track) return;
    var dots = document.querySelector("[data-dr-gallery-dots]");
    var thumbs = Array.prototype.slice.call(document.querySelectorAll("[data-dr-thumb]"));
    var gPrev = document.querySelector("[data-dr-gallery-prev]");
    var gNext = document.querySelector("[data-dr-gallery-next]");
    var gCount = track.children.length;
    var gIndex = function () { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); };
    var gGo = function (i) {
      i = Math.max(0, Math.min(gCount - 1, i));
      var still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      track.scrollTo({ left: i * track.clientWidth, behavior: still ? "auto" : "smooth" });
    };
    var gSync = function () {
      var i = gIndex();
      if (dots) Array.prototype.forEach.call(dots.children, function (d, n) {
        if (n === i) d.setAttribute("data-on", ""); else d.removeAttribute("data-on");
      });
      thumbs.forEach(function (b, n) { if (n === i) b.setAttribute("aria-current", "true"); else b.removeAttribute("aria-current"); });
      if (gPrev) gPrev.disabled = i === 0;
      if (gNext) gNext.disabled = i === gCount - 1;
    };
    track.addEventListener("scroll", gSync, { passive: true });
    thumbs.forEach(function (b) { b.addEventListener("click", function () { gGo(Number(b.getAttribute("data-dr-thumb"))); }); });
    if (gPrev) gPrev.addEventListener("click", function () { gGo(gIndex() - 1); });
    if (gNext) gNext.addEventListener("click", function () { gGo(gIndex() + 1); });
    gSync();
  }
  initGallery();

  /* --- colorways (Gibbs 2026-10-26): each swatch is a real link to a sibling product (no JS = it just
     navigates). With JS the product section is fetched with ?section_id= and swapped in place: photos,
     sizes, stock and the add-to-cart form all belong to the new colorway; the picked size carries over. */
  var swapCache = {}, swapped = false;
  function sectionUrl(href, sid) { var u = new URL(href, location.href); u.searchParams.set("section_id", sid); return u.toString(); }
  function fetchSection(href, sid) {
    var key = sectionUrl(href, sid);
    if (!swapCache[key]) {
      swapCache[key] = fetch(key, { credentials: "same-origin" }).then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.text();
      });
      swapCache[key]["catch"](function () { delete swapCache[key]; });
    }
    return swapCache[key];
  }
  /* Load the new colorway's lead photo before swapping, so the gallery never sits blank (max 1.5s). */
  function parseRoot(html) { return new DOMParser().parseFromString(html, "text/html").querySelector("[data-dr-pdp-root]"); }
  function warmLead(next) {
    var img = next && next.querySelector("[data-dr-gallery-track] img");
    if (!img) return Promise.resolve();
    return new Promise(function (done) {
      var pre = new Image();
      pre.onload = pre.onerror = done;
      if (img.getAttribute("sizes")) pre.sizes = img.getAttribute("sizes");
      if (img.getAttribute("srcset")) pre.srcset = img.getAttribute("srcset");
      pre.src = img.getAttribute("src");
      setTimeout(done, 1500);
    });
  }
  function swapColor(a) {
    var root = a.closest("[data-dr-pdp-root]");
    var sid = root && root.getAttribute("data-dr-section");
    if (!sid || !window.DOMParser || !history.pushState) { location.href = a.href; return; }
    var picked = root.querySelector('input[name="options[Size]"]:checked');
    var size = picked && picked.value;
    var oldTitle = root.getAttribute("data-dr-title");
    root.setAttribute("aria-busy", "true");
    fetchSection(a.href, sid).then(function (html) {
      var parsed = parseRoot(html);
      if (!parsed) throw new Error("section missing");
      return warmLead(parsed).then(function () { return parsed; });
    }).then(function (parsed) {
      var next = document.importNode(parsed, true);
      root.replaceWith(next);
      if (size) Array.prototype.forEach.call(next.querySelectorAll('input[name="options[Size]"]'), function (i) {
        if (i.value === size && !i.disabled) i.checked = true;
      });
      var newTitle = next.getAttribute("data-dr-title");
      if (oldTitle && newTitle) document.title = document.title.replace(oldTitle, newTitle);
      history.pushState({ drPdp: true }, "", a.href);
      swapped = true;
      initPdp();
      initGallery();
      if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) Shopify.PaymentButton.init();
      var cur = next.querySelector('[data-dr-swatch][aria-current="true"]');
      if (cur) cur.focus({ preventScroll: true });
    })["catch"](function () { location.href = a.href; });
  }
  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest("[data-dr-swatch]");
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    if (a.getAttribute("aria-current") !== "true") swapColor(a);
  });
  /* warm the next colorway on hover/focus so the swap feels instant */
  ["pointerover", "focusin"].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var a = e.target.closest && e.target.closest("[data-dr-swatch]");
      var root = a && a.closest("[data-dr-pdp-root]");
      if (a && root && a.getAttribute("aria-current") !== "true") {
        fetchSection(a.href, root.getAttribute("data-dr-section")).then(function (html) { warmLead(parseRoot(html)); })["catch"](function () {});
      }
    });
  });
  /* Back/forward after a swap: the URL changed but the page did not, so load the page the URL names. */
  window.addEventListener("popstate", function () { if (swapped) location.reload(); });
})();
